import AgentFlow from './AgentFlow';
import Glossary from './Glossary';
import InternetExplorer from './InternetExplorer';
import Minesweeper from './Minesweeper';
import ErrorBox from './ErrorBox';
import Notepad from './Notepad';
import Winamp from './Winamp';
import Paint from './Paint';
import WhoAmI from './WhoAmI';
import Experience from './Experience';
import Skills from './Skills';
import Contact from './Contact';
import MyDocuments from './MyDocuments';
import Claude from './Claude';
import MarioGame from './MarioGame';
import RoadRash from './RoadRash';
import BigFlappyBird from './BigFlappyBird';

import mine from 'assets/minesweeper/mine-icon.png';
import error from 'assets/windowsIcons/897(16x16).png';
import computer from 'assets/windowsIcons/676(16x16).png';
import computerLarge from 'assets/windowsIcons/676(32x32).png';
import notepad from 'assets/windowsIcons/327(16x16).png';
import notepadLarge from 'assets/windowsIcons/327(32x32).png';
import winamp from 'assets/windowsIcons/winamp.png';
import paintLarge from 'assets/windowsIcons/680(32x32).png';
import paint from 'assets/windowsIcons/680(16x16).png';
import folder from 'assets/windowsIcons/318(16x16).png';
import folderLarge from 'assets/windowsIcons/318(48x48).png';
import cmd from 'assets/windowsIcons/56(16x16).png';
import outlook from 'assets/windowsIcons/887(16x16).png';
import outlookLarge from 'assets/windowsIcons/887(32x32).png';
import ie from 'assets/windowsIcons/ie.png';
import iePaper from 'assets/windowsIcons/ie-paper.png';
import ieLarge from 'assets/windowsIcons/ie.png';
import ieBook from 'assets/windowsIcons/ie-book.png';
import claudeIcon from 'assets/windowsIcons/claude.ico';
import marioIcon from 'assets/windowsIcons/mario-logo.png';
import pinball from 'assets/windowsIcons/pinball.png';
import documentsLarge from 'assets/windowsIcons/308(32x32).png';
import documentsSmall from 'assets/windowsIcons/308(16x16).png';
import linkedinIcon from 'assets/windowsIcons/linkedin.png';
import flappyBirdIcon from 'assets/windowsIcons/flappy-bird.png';
import githubLogo from 'assets/github-logo.png';
import agentFlowIcon from 'assets/windowsIcons/agent-flow.png';
import weightLossIcon from 'assets/windowsIcons/weight-loss.png';
import mahflowIcon from 'assets/windowsIcons/mahflow.png';
import newsletterIcon from 'assets/windowsIcons/newsletter.png';
import { AGENT_FLOW_COURSE_URL } from 'config/agentFlow';

const gen = () => {
  let id = -1;
  return () => { id += 1; return id; };
};
const genId = gen();
const genIndex = gen();

export const defaultAppState = [
  {
    component: WhoAmI,
    header: { title: 'mahip.exe', icon: computer },
    defaultSize: { width: 700, height: 500 },
    defaultOffset: { x: 130, y: 20 },
    resizable: true,
    minimized: true,
    maximized: window.innerWidth < 800,
    id: genId(),
    zIndex: genIndex(),
  },
  {
    component: Minesweeper,
    header: { title: 'Minesweeper', icon: mine },
    defaultSize: { width: 0, height: 0 },
    defaultOffset: { x: 220, y: 180 },
    resizable: false,
    minimized: true,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
  },
  {
    component: Winamp,
    header: { title: 'Winamp', icon: winamp, invisible: true },
    defaultSize: { width: 0, height: 0 },
    defaultOffset: { x: 0, y: 0 },
    resizable: false,
    minimized: true,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
  },
];

export const defaultIconState = [
  {
    id: 0,
    icon: computerLarge,
    title: 'mahip.exe',
    component: WhoAmI,
    isFocus: false,
  },
  {
    id: 1,
    icon: folderLarge,
    title: 'experience.log',
    component: Experience,
    isFocus: false,
  },
  {
    id: 2,
    icon: notepadLarge,
    title: 'stack_overflow.exe',
    component: Skills,
    isFocus: false,
  },
  {
    id: 3,
    icon: outlookLarge,
    title: 'Outlook Express',
    component: Contact,
    isFocus: false,
  },
  {
    id: 4,
    icon: mine,
    title: 'Minesweeper',
    component: Minesweeper,
    isFocus: false,
  },
  {
    id: 5,
    icon: winamp,
    title: 'Winamp',
    component: Winamp,
    isFocus: false,
  },
  {
    id: 6,
    icon: paintLarge,
    title: 'Paint',
    component: Paint,
    isFocus: false,
  },
  {
    id: 7,
    icon: documentsLarge,
    title: 'My Documents',
    component: MyDocuments,
    isFocus: false,
  },
  {
    id: 8,
    icon: ieLarge,
    title: 'Internet Explorer',
    component: InternetExplorer,
    isFocus: false,
  },
  {
    id: 9,
    icon: claudeIcon,
    title: 'Claude AI',
    component: Claude,
    isFocus: false,
  },
  {
    id: 10,
    icon: marioIcon,
    title: 'Super PM Bros.',
    component: MarioGame,
    isFocus: false,
  },
  {
    id: 11,
    icon: pinball,
    title: 'Road Rash: AI Edition',
    component: RoadRash,
    isFocus: false,
  },
  {
    id: 12,
    icon: linkedinIcon,
    title: 'LinkedIn',
    url: 'https://www.linkedin.com/in/mahip-kakan/',
    isFocus: false,
  },
  {
    id: 14,
    icon: githubLogo,
    title: 'GitHub',
    url: 'https://github.com/mahip-kakan',
    isFocus: false,
  },
  {
    id: 15,
    icon: ieLarge,
    title: 'Workflow Studio',
    url: 'https://mahip-kakan.github.io/Work-Flow/',
    isFocus: false,
  },
  {
    id: 16,
    icon: agentFlowIcon,
    title: 'AgentCraft',
    component: AgentFlow,
    isFocus: false,
  },
  {
    id: 20,
    icon: ieBook,
    title: 'glossary.exe',
    component: Glossary,
    isFocus: false,
  },
  {
    id: 13,
    icon: flappyBirdIcon,
    title: 'Flappy Bird Lateral Raises',
    component: BigFlappyBird,
    isFocus: false,
  },
  {
    id: 17,
    icon: weightLossIcon,
    title: 'Weight Loss Journey',
    url: 'https://timesofindia.indiatimes.com/life-style/health-fitness/weight-loss/this-guy-followed-this-new-kind-of-diet-and-lost-54-kilos/articleshow/63123395.cms',
    isFocus: false,
  },
  {
    id: 18,
    icon: mahflowIcon,
    title: 'Mahflow',
    url: 'https://github.com/mahip-kakan/Mahflow/releases/latest',
    isFocus: false,
  },
  {
    id: 19,
    icon: newsletterIcon,
    title: 'Newsletter',
    url: 'https://www.linkedin.com/build-relation/newsletter-follow?entityUrn=7446461748267630592',
    isFocus: false,
  },
];

export const appSettings = {
  'mahip.exe': {
    header: { icon: computer, title: 'mahip.exe' },
    component: WhoAmI,
    defaultSize: { width: 700, height: 500 },
    defaultOffset: { x: 140, y: 30 },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'experience.log': {
    header: { icon: folder, title: 'experience.log' },
    component: Experience,
    defaultSize: { width: 720, height: 520 },
    defaultOffset: { x: 160, y: 40 },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'stack_overflow.exe': {
    header: { icon: cmd, title: 'stack_overflow.exe' },
    component: Skills,
    defaultSize: { width: 700, height: 500 },
    defaultOffset: { x: 170, y: 50 },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Outlook Express': {
    header: { icon: outlook, title: 'Outlook Express' },
    component: Contact,
    defaultSize: { width: 600, height: 440 },
    defaultOffset: { x: 180, y: 60 },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Minesweeper: {
    header: { icon: mine, title: 'Minesweeper' },
    component: Minesweeper,
    defaultSize: { width: 0, height: 0 },
    defaultOffset: { x: 190, y: 180 },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  Error: {
    header: {
      icon: error,
      title: 'C:\\',
      buttons: ['close'],
      noFooterWindow: true,
    },
    component: ErrorBox,
    defaultSize: { width: 380, height: 0 },
    defaultOffset: {
      x: window.innerWidth / 2 - 190,
      y: window.innerHeight / 2 - 60,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  Notepad: {
    header: { icon: notepad, title: 'Untitled - Notepad' },
    component: Notepad,
    defaultSize: { width: 660, height: 500 },
    defaultOffset: { x: 270, y: 60 },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  Winamp: {
    header: { icon: winamp, title: 'Winamp', invisible: true },
    component: Winamp,
    defaultSize: { width: 0, height: 0 },
    defaultOffset: { x: 0, y: 0 },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  Paint: {
    header: { icon: paint, title: 'Untitled - Paint' },
    component: Paint,
    defaultSize: { width: 660, height: 500 },
    defaultOffset: { x: 280, y: 70 },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  'Internet Explorer': {
    header: { icon: iePaper, title: 'Internet Explorer' },
    component: InternetExplorer,
    defaultSize: { width: 700, height: 500 },
    defaultOffset: { x: 140, y: 30 },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  'Super PM Bros.': {
    header: { icon: marioIcon, title: 'Super PM Bros.' },
    component: MarioGame,
    defaultSize: { width: 500, height: 340 },
    defaultOffset: { x: 160, y: 60 },
    resizable: false,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Claude AI': {
    header: { icon: claudeIcon, title: 'Claude AI — Please Wait' },
    component: Claude,
    defaultSize: { width: 460, height: 420 },
    defaultOffset: { x: 200, y: 80 },
    resizable: false,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Road Rash: AI Edition': {
    header: { icon: pinball, title: 'Road Rash: AI Edition' },
    component: RoadRash,
    defaultSize: { width: 620, height: 430 },
    defaultOffset: { x: 160, y: 50 },
    resizable: false,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Flappy Bird Lateral Raises': {
    header: { icon: flappyBirdIcon, title: 'Flappy Bird Lateral Raises' },
    component: BigFlappyBird,
    defaultSize: { width: 720, height: 620 },
    defaultOffset: { x: 150, y: 40 },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'My Documents': {
    header: { icon: documentsSmall, title: 'My Documents' },
    component: MyDocuments,
    defaultSize: { width: 680, height: 480 },
    defaultOffset: { x: 150, y: 40 },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  AgentCraft: {
    header: { icon: agentFlowIcon, title: 'AgentCraft' },
    component: AgentFlow,
    defaultSize: { width: 960, height: 640 },
    defaultOffset: { x: 60, y: 20 },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'glossary.exe': {
    header: { icon: ieBook, title: 'glossary.exe' },
    component: Glossary,
    defaultSize: { width: 980, height: 640 },
    defaultOffset: { x: 50, y: 16 },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
};

export { InternetExplorer, Minesweeper, ErrorBox, Notepad, Winamp, WhoAmI, Experience, Skills, Contact, MyDocuments };
